import Table from "../../components/table/Table";
import {getDailyReport} from "../../api/getDailyReport";
import {ColProps, colTypeOptions, FetchProps, FilterProps, filterTypeOptions} from "../../components/table/tableTypes";
import {
    dateDaysAgo,
    formatDate,
    millisecondsToHuman,
    shortFormatDate,
    shortFormatDateNoTime
} from "../../utils/friendlyDate";
import useAppContext from "../../hooks/useAppContext";
import {useEffect, useState} from "react";
import {MenuProps, Tooltip} from "antd";
import {exportToCsv} from "../../utils/exportToCsv";
import {getMessagesLog} from "../../api/getMessagesLog";
import {StatusView} from "./StatusView";
import {MessageTemplateProps} from "../../types/MessageTemplateProps";
import {STATUS_OPTIONS} from "../../consts/statusOptions";
import CheckoutPanel from "../../components/checkoutPanel/CheckoutPanel";
import {formatPhoneNumber} from "../../utils/friendlyPhone";
import {Campaign} from "../../types/CampaignProps";

const MessagesLog = () => {
    const { data: { templates, campaigns } } = useAppContext();
    const [checkoutId, setCheckoutId] = useState<number | undefined>(undefined);
    const [templatesOptions, setTemplatesOptions] = useState<MenuProps['items'] | null>(null);
    const [campaignsOptions, setCampaignsOptions] = useState<MenuProps['items'] | null>(null);

    const fetch = async ({ filters, sortingBy, sortingDirection, limit, offset, selectedDomain, isCsvCall, page, pageSize }: FetchProps) => {
        const response = await getMessagesLog(selectedDomain, filters, page, pageSize);
        if(isCsvCall) {
            exportToCsv(response.data.report, `Vuelve Messages Log - ${selectedDomain} - ${formatDate(new Date())}`);
        } else {
            return selectedDomain ? response : [];
        }
    }

    useEffect(() => {
        templates.isLoaded && setTemplatesOptions(templates.data.map((template: MessageTemplateProps) => ({ key: template.id, label: template.title })))
    }, [templates.data, templates.isLoaded]);

    useEffect(() => {
        campaigns.isLoaded && setCampaignsOptions(campaigns.data.map((campaign: Campaign) => ({ key: campaign.id, label: campaign.title })))
    }, [campaigns.data, campaigns.isLoaded]);

    const onCheckoutClick = (row: any) => {
        setCheckoutId(row.checkout_id);
    }

    const cols: ColProps[] = [
        { key: 'status', name: '', type: colTypeOptions.text, maxWidth: 35, paddingLeft: 0, render: (value: string, row: any) => {
            return <StatusView value={value} errorMessage={row.reason} />;
        } },
        { key: 'message_id', name: 'Message', type: colTypeOptions.text, paddingLeft: 0, isPinned: true, width: 60 },
        { key: 'trigger', name: 'Trigger', type: colTypeOptions.text, paddingLeft: 0, isPinned: true, width: 60, render: (value: string, row: any) => {
            if(row.campaign_id) return <span className="status orange-label">Campaign</span>;
                else if(row.event_id) return <span className="status pink-label">Event</span>;
            return <span className="status purple-label">Recovery</span>;
        } },
        { key: 'created_at', name: 'Delivery', type: colTypeOptions.date, width: 160, isPinned: true, render: (value: Date) => shortFormatDate(new Date(value)) },
        { key: 'clicks', name: 'Clicks', maxWidth: 80, type: colTypeOptions.number, render: (value: number, row: any) => <Tooltip title={row.last_click ? shortFormatDate(new Date(row.last_click)) : ''}>{value}</Tooltip> },
        { key: 'template_title', name: 'Template', type: colTypeOptions.text, width: 150 },
        // { key: 'checkout_id', name: 'Checkout', type: colTypeOptions.text, width: 90 },
        { key: 'receiver_client_id', name: 'Client', type: colTypeOptions.text, width: 120, render: (value: number, row: any) => <Tooltip title={`ID: ${value}`}><div className="capitalize">{row.full_name}</div></Tooltip> },
        { key: 'receiver_phone_number', name: 'Phone', type: colTypeOptions.text, width: 130, render: (value: string) => formatPhoneNumber(value) },
        // { key: 'actual_delay', name: 'Delay', type: colTypeOptions.number, width: 90, render: (value: number) => millisecondsToHuman(value*1000) },
        // { key: 'desired_delay', name: 'Desired Delay', type: colTypeOptions.number, width: 120, render: (value: number) => millisecondsToHuman(value*1000) },
    ];

    const filters: FilterProps[] = templatesOptions && campaignsOptions ? [
        { filterKey: 'days', name: 'date range', type: filterTypeOptions.date, min: dateDaysAgo(30), max: new Date(), from: dateDaysAgo(7), to: new Date() },
        { filterKey: 'templates', name: 'templates', type: filterTypeOptions.textToId, options: templatesOptions, allLabel: 'All Templates', selected: 0 },
        { filterKey: 'campaigns', name: 'campaigns', type: filterTypeOptions.textToId, options: campaignsOptions, allLabel: 'All Campaigns', selected: 0 },
        { filterKey: 'status', name: 'status', type: filterTypeOptions.textToKey, options: STATUS_OPTIONS, allLabel: 'All Statuses', selected: 0 },
        { filterKey: 'clientId', name: 'client ID', type: filterTypeOptions.text },
        { filterKey: 'checkoutId', name: 'checkout ID', type: filterTypeOptions.text },
        { filterKey: 'phone', name: 'phone', type: filterTypeOptions.text }
    ] : [];

    return (
        <div className="reports-container">
            {templatesOptions && campaignsOptions ? <Table onRowClick={onCheckoutClick} title="Messages Log" fetch={fetch} cols={cols} filters={filters} showSearch={false} doneLoadingDependencies={templates.isLoaded} /> : null}
            <CheckoutPanel checkoutId={checkoutId} onClose={() => setCheckoutId(undefined)} />
        </div>
    );
}

export default MessagesLog;